import Vue from 'vue';
import Vuex from 'vuex';
import 'babel-polyfill';

Vue.use(Vuex);

const state = {
    user: {
        id: 0,
        name: 'guest',
        email: 'gu@e.st',
        uuid: 0
    },
    website: {
        id: 0,
        name: '请选择站点'
    },
    maskShown: {isShow: false, zIndex: 9999},
    minHeight: 768,
    contentWidth: 1200,
    appUrls: {
        app_url: '',
        mc_url: '',
        open_url: '',
        uc_url: '',
        wx_appid: '',
        wx_plat_appid: '',
        wx_push_appid: ''
    }
};

const getters = {};

const mutations = {
    user (state, user) {
        state.user = {...user};
    },
    mask (state, shown) {
        state.maskShown = shown;
    },
    website (state, site) {
        state.website = {...site};
        state.website.url = `${site.proto}://${site.domain}`;
    },
    appUrls (state, urls) {
        state.appUrls = {...urls};
    },
    minHeight (state, val) {
        state.minHeight = val;
    },
    contentWidth (state, val) {
        state.contentWidth = val;
    }
};

export default new Vuex.Store({
    state,
    getters,
    mutations
});
